import { useParams } from "react-router-dom";
import DropdownMenu from "../../component/DropdownMenu";
import Footer from "../../component/Footer";
import Navbar from "../../component/Navbar";

import {
  DataSurgery_1,
  DataSurgery_2,
  DataSurgery_3,
  DataSurgery_4,
  DataSurgery_5,
} from "../../inc/DataSurgery";

const surgeryComponents = {
  1: DataSurgery_1,
  2: DataSurgery_2,
  3: DataSurgery_3,
  4: DataSurgery_4,
  5: DataSurgery_5,
};

export default function Surgery() {
  const { id } = useParams();
  const Component = surgeryComponents[id];
  return (
    <>
      <Navbar />
      <DropdownMenu />
      <div className="max-w-5xl mx-auto container h-full ">
        {Component ? <Component /> : <span>ไม่พบข้อมูล</span>}
      </div>
      <Footer />
    </>
  );
}
